// eslint-disable-next-line no-unused-vars
function showHidePasswordInput(selectors) {
    selectors.forEach((button) => {
        button.addEventListener('click', (event) => {
            // eslint-disable-next-line no-shadow
            const passwordInput = event.currentTarget.previousElementSibling;

            if (passwordInput.type === "password") {
                passwordInput.type = "text";
                button.src = "https://images.paw-champ.com/pc/icons/eye-icon-gray.svg";
            } else {
                passwordInput.type = "password";
                button.src = "https://images.paw-champ.com/pc/icons/eye-slash-icon-gray.svg";
            }
        });
    });
}

export { showHidePasswordInput };
